<app-status-page [fullPage]="true" kind="not-found" code="Error 404"
                 title="We couldn't find that page"
                 message="The link may be out of date, or the page may have moved. Check the address, or head back to Smart TOS.">
  @if (canGoBack) {
    <button type="button" class="btn secondary_button" (click)="goBack()">Go back</button>
  }
  <button type="button" class="btn primary_button" (click)="goToHome()">Go to Smart TOS</button>
</app-status-page>
